import { render, staticRenderFns } from "./ItemDamageDiscrepancy.vue?vue&type=template&id=6a2e31a9&"
import script from "./ItemDamageDiscrepancy.vue?vue&type=script&lang=js&"
export * from "./ItemDamageDiscrepancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports